import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SolutionsSection } from './components/SolutionsSection';
import { MessageTypesSection } from './components/MessageTypesSection';
import { ProductReveal } from './components/ProductReveal';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    ;
    (window as any).fbq('init', '1416879016313040');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-body text-gray-800 bg-cream flex flex-col" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1416879016313040&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <StickyAlertBar data-id="element-3" />

      <main className="flex-grow" data-id="element-4">
        <HeroSection data-id="element-5" />
        <PainPointsSection data-id="element-6" />
        <SolutionsSection data-id="element-7" />
        <ProductReveal data-id="element-8" />
        <MessageTypesSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <BonusSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}